interface IconProps {
  className?: string;
}

const UndIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <g clipPath="url(#clip0_12629_159599)">
        <mask
          id="mask0_12629_159599"
          width="16"
          height="16"
          x="1"
          y="1"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
        >
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </mask>
        <g mask="url(#mask0_12629_159599)">
          <path
            fill="currentColor"
            d="M9.333 6.333c-1.766 0-3.366.66-4.6 1.734l-1.26-1.26c-.42-.42-1.14-.127-1.14.466V11c0 .367.3.667.667.667h3.727c.593 0 .893-.72.473-1.14L5.927 9.253A5.3 5.3 0 0 1 9.34 8a5.34 5.34 0 0 1 4.793 3 .82.82 0 0 0 1 .427.837.837 0 0 0 .5-1.147c-1.146-2.333-3.533-3.947-6.3-3.947"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_12629_159599">
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default UndIcon;
